module.exports = __webpack_public_path__ + "media/images/icons/header-474b4a2b630915f0ce0a4f5051ef55d7.svg";